import { legacy_createStore as createStore, compose } from 'redux';
import rootReducer from './reducers';
import type { ReduxStore } from './types';

const devInClient =
  import.meta.env.TARGET_ENV === 'dev' && !import.meta.env.SSR;

const composeEnhancers =
  devInClient && (window as any)?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const createStoreWithMiddleware =
  composeEnhancers(/* Add middlewares here */)(createStore);

export default (initialState: ReduxStore) =>
  createStoreWithMiddleware(rootReducer, initialState);
